import React, { useRef, useEffect, FC } from 'react'
import Slider, { Settings } from 'react-slick'
import StylesSlickCarousel from './styles'

const SlickCarousel: FC<SlickCarouselProps> = ({
  settings,
  children,
  className,
  setSliderRef
}) => {
  const sliderRef = useRef<Slider | null>(null)

  useEffect(() => {
    if (setSliderRef) {
      setSliderRef(sliderRef.current)
    }
  }, [setSliderRef])

  return (
    <div>
      <div className={className}>
        <Slider {...settings} ref={sliderRef}>
          {children}
        </Slider>
      </div>
      <StylesSlickCarousel />
    </div>
  )
}

interface SlickCarouselProps {
  settings: Settings
  children: React.ReactNode
  className?: string
  setSliderRef?: (ref: Slider | null) => void
}

export default SlickCarousel